<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  selectedDatetime: {
    type: Date,
    default: null,
  },
});

const emit = defineEmits(['select']);

const { t } = useI18n();

const shortcuts = computed(() => {
  const now = new Date();
  now.setSeconds(0, 0);

  return [
    {
      label: t('SCHEDULED_MESSAGES.SHORTCUTS.IN_1_HOUR'),
      value: new Date(now.getTime() + 60 * 60 * 1000),
    },
    {
      label: t('SCHEDULED_MESSAGES.SHORTCUTS.IN_2_HOURS'),
      value: new Date(now.getTime() + 2 * 60 * 60 * 1000),
    },
    {
      label: t('SCHEDULED_MESSAGES.SHORTCUTS.TOMORROW_9AM'),
      value: (() => {
        const tomorrow = new Date(now);
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(9, 0, 0, 0);
        return tomorrow;
      })(),
    },
    {
      label: t('SCHEDULED_MESSAGES.SHORTCUTS.MONDAY_9AM'),
      value: (() => {
        const monday = new Date(now);
        const daysUntilMonday = (1 + 7 - monday.getDay()) % 7 || 7;
        monday.setDate(monday.getDate() + daysUntilMonday);
        monday.setHours(9, 0, 0, 0);
        return monday;
      })(),
    },
  ];
});

const selectShortcut = shortcut => {
  emit('select', shortcut.value);
};
</script>

<template>
  <div class="flex flex-wrap gap-2">
    <button
      v-for="shortcut in shortcuts"
      :key="shortcut.label"
      type="button"
      class="px-3 py-1.5 text-sm text-n-text dark:text-n-text-white border border-n-divider rounded-lg hover:bg-n-surface-1 dark:hover:bg-n-surface-3 transition-colors whitespace-nowrap"
      @click="selectShortcut(shortcut)"
    >
      {{ shortcut.label }}
    </button>
  </div>
</template>